import { ProductTabs as AdvoxProductTabs } from 'AdvoxComponent/ProductTabs/ProductTabs.component';
import { SCROLL_TO_TAB_OFFSET } from 'Component/ProductTabs/ProductTabs.config';

/** @namespace Pwa/Component/ProductTabs/Component */
export class ProductTabs extends AdvoxProductTabs {
    onTabClick = (tab) => {
        const { tabs } = this.props;
        const { activeTab } = this.state;
        const { id } = tabs.find(({ name }) => name === tab);
        const currentTab = tabs.findIndex(({ name }) => name === tab);

        if (activeTab !== currentTab) {
            const { tabKey } = tabs[currentTab];

            const tabContent = document.getElementById(tabKey);

            if (tabContent && !tabContent.classList.contains('ExpandableContent-Button_isContentExpanded')) {
                const event = new MouseEvent('click', {
                    view: window,
                    bubbles: true,
                    cancelable: true,
                });

                tabContent.dispatchEvent(event);
            }

            if (tabContent) {
                const { top } = tabContent.getBoundingClientRect();
                window.scrollTo({ top: top + window.scrollY - SCROLL_TO_TAB_OFFSET, behavior: 'smooth' });
            }

            this.setState({
                activeTab: id,
            });
        }
    };
}

export default ProductTabs;
